import moment from "moment";
import httpRequest from "./httpreq";
import { isFunction, isDefined, isTrue, getKey, logStdout, getSystemTime } from "../shared/utils";
import { formatDate } from "../shared/filters";
import { delMediaFiles } from "./media";
import { DRYEYEMENUS, TOPOGRAPHYCAMPTUREMODES, _DATEFORMATS } from "../shared/consts";
import fileSys from "../fileoprators/fileSystem";
const fs = window.require("fs");

export const addRecord = (record, callback) => {
  let result = {
    message: "OK"
  };
  if (!isDefined(record.checktype)) {
    throw new Error(`'checktype is needed'`);
  }
  let opt = {
    cmd: "addRecord",
    body: record,
    token: window.token
  };
  httpRequest(opt, (data) => {
    logStdout("add record", opt.body, window.session.user.username);
    fileSys.syncDisk();
    if (data.message === "OK") {
      if (data.obj.record.recorddate) {
        data.obj.record.recorddate = getSystemTime();
      }
      result.record = data.obj.record;
    } else {
      result = {
        message: "failed",
        error: data.error
      };
    }
    if (isFunction(callback)) {
      callback(result);
    }
  });
};

export const getAllRecords = (checktype, allRecords, patientid, callback) => {
  var opt = {
    cmd: "getRecordsAll",
    body: {
      page: 1,
      pagelength: 50,
      patientid: patientid,
      search: {
        checktype: checktype
      }
    },
    token: global.session.obj.token
  };
  httpRequest(opt, (response) => {
    // var res = response
    if (response.message === "OK") {
      allRecords = allRecords.concat(response.obj.records);
      if (response.obj.records.length >= 50) {
        getAllRecords(checktype, allRecords, callback);
      } else {
        if (typeof callback === "function" && callback) {
          callback(allRecords);
        }
      }
    } else {
      console.log("error", response);
    }
  });
};
export const deleteRecords = (records, callback) => {
  if (records.length <= 0) {
    if (isFunction(callback)) {
      callback({
        message: "OK"
      });
    }
  } else {
    let record = records.pop();
    deleteRecord(null, record, (data) => {
      if (data.message === "OK") {
        deleteRecords(records, callback);
      } else {
        callback({
          message: "failed"
        });
      }
    });
  }
};
export const deleteRecord = (_id, record, callback) => {
  if (isDefined(record)) {
    delLocalFiles(fileSys.getCasePath(record._id + "_OD"));
    delLocalFiles(fileSys.getCasePath(record._id + "_OS"));
    let fileinfos = getFileinfos(record);
    delMediaFiles(fileinfos, () => {
      deleteRecordDB(record._id, callback);
    });
  } else {
    getRecordContent(_id, (res) => {
      if (res.record) {
        let record = res.record;
        delLocalFiles(fileSys.getCasePath(_id + "_OD"));
        delLocalFiles(fileSys.getCasePath(_id + "_OS"));
        let fileinfos = getFileinfos(record);
        delMediaFiles(fileinfos, () => {
          deleteRecordDB(_id, callback);
        });
      } else {
        let result = {
          message: "failed"
        };
        if (isFunction(callback)) {
          callback(result);
        }
      }
    });
  }
};
export const deleteRecordDB = (_id, callback) => {
  let result = {
    message: "OK"
  };
  let opt = {
    cmd: "delRecord",
    body: {
      _id: _id
    },
    token: window.token
  };
  logStdout("delete record", _id, window.session.user.username);
  httpRequest(opt, (data) => {
    fileSys.syncDisk();
    if (data.message !== "OK") {
      result = {
        message: "failed",
        error: data.error
      };
    }
    if (isFunction(callback)) {
      callback(result);
    }
  });
};
const _getRecords = (cmd, patientid, search, callback, page = 1) => {
  let result = {
    message: "OK"
  };
  let opt = {
    cmd: cmd,
    body: {
      page: page,
      pagelength: 50,
      patientid: patientid,
      search: search
    },
    token: window.token
  };

  httpRequest(opt, (data) => {
    if (data.message === "OK") {
      result.records = data.obj.records;
    } else {
      result = {
        message: "failed",
        error: data.error
      };
    }
    if (isFunction(callback)) {
      callback(result);
    }
  });
};
// 此接口中，拿到的数据中是不包含content的最多50个病例
export const getRecords = (patientid, search, callback, page = 1) => {
  _getRecords(
    "getRecords",
    patientid,
    search,
    (data) => {
      if (isFunction(callback)) {
        callback(data);
      }
    },
    page
  );
};
// 此接口中，拿到的数据中包含content的最多50个病例
export const getRecordsAll = (patientid, search, callback, page = 1) => {
  _getRecords(
    "getRecordsAll",
    patientid,
    search,
    (data) => {
      if (isFunction(callback)) {
        callback(data);
      }
    },
    page
  );
};

// 获取单个病例的所有信息
export const getRecordContent = (_id, callback) => {
  let result = {
    message: "OK"
  };
  let opt = {
    cmd: "getRecordContent",
    body: {
      _id: _id
    },
    token: window.token
  };
  httpRequest(opt, (data) => {
    if (data.message === "OK") {
      result.record = data.obj.record;
    } else {
      result = {
        message: "falied",
        error: data.error
      };
    }
    if (isFunction(callback)) {
      callback(result);
    }
  });
};
export const updateRecord = (record, callback) => {
  let result = {
    message: "OK"
  };
  let opt = {
    cmd: "updateRecord",
    body: record,
    token: window.token
  };
  httpRequest(opt, (data) => {
    logStdout("update record", opt.body, window.session.user.username);
    fileSys.syncDisk();
    if (data.message === "OK") {
      result.record = record;
    } else {
      result = {
        message: "failed",
        error: data.error
      };
    }
    if (isFunction(callback)) {
      callback(result);
    }
  });
};
export const reloadRecords = (callback) => {
  let opt = {
    cmd: "reloadRecords",
    token: window.token
  };
  httpRequest(opt, (data) => {
    if (isFunction(callback)) {
      callback(data);
    }
  });
};
export const getAllRecordsOfPatientWithoutContent = (
  patientid,
  search = {},
  callback,
  records = [],
  page = 1
) => {
  let result = {
    message: "OK"
  };
  if (!Array.isArray(records)) {
    throw new Error("records should be an array!");
  }
  _getRecords(
    "getRecords",
    patientid,
    search,
    (data) => {
      if (data.message === "OK") {
        records = records.concat(data.records);
        if (data.records.length >= 50) {
          page += 1;
          getAllRecordsOfPatientWithoutContent(patientid, search, callback, records, page);
        } else {
          result.records = records;
          if (isFunction(callback)) {
            callback(result);
          }
        }
      } else {
        result.message = "failed";
        result.records = records;
        if (isFunction(callback)) {
          callback(result);
        }
      }
    },
    page
  );
};
export const getAllRecordsOfPatientWithContent = (
  patientid,
  search = {},
  callback,
  recs = [],
  page = 1
) => {
  let _search = search || {};
  let result = {
    message: "OK"
  };
  getRecordsAll(
    patientid,
    _search,
    (data) => {
      if (data.message === "OK") {
        recs = recs.concat(data.records);
        if (data.records.length >= 50) {
          page++;
          getAllRecordsOfPatientWithContent(patientid, search, callback, recs, page);
        } else {
          result.records = recs;
          callback(result);
        }
      } else {
        result.message = "failed";
        if (isFunction(callback)) {
          callback(result);
        }
      }
    },
    page
  );
};
export const recordHeaders = [
  {
    prop: "recorddate",
    options: {
      dateFormat: _DATEFORMATS[window.settings.dateFormat].label
    },
    label: "txtCheckTime"
  },
  {
    prop: "checktype",
    label: "txtCheckMode"
  },
  {
    prop: "eyetype",
    width: "150",
    label: "txtEye"
  }
];

export const recordExportHeaders = [
  {
    prop: "recorddate",
    options: {
      dateFormat: _DATEFORMATS[window.settings.dateFormat].label
    },
    label: "txtCheckTime"
  },
  {
    prop: "checktype",
    label: "txtCheckMode"
  },
  {
    prop: "eyetype",
    width: "150",
    label: "txtEye"
  }
];

const procData = (v, key, options, langs) => {
  switch (key) {
    case "operation":
      return "✘";
    case "recorddate":
      return formatDate(v, options.dateFormat, true, false);
    case "eyetype":
      return isDefined(v) ? v.join(",") : "";
    case "checktype":
      return langs[v];
  }

  return v;
};
function isCheckItemDiagnosed(record, eyetype) {
  let et = eyetype;
  return (
    isDefined(record) &&
    isDefined(record.content) &&
    isDefined(record.content[`data${et}`]) &&
    isTrue(record.content[`data${et}`].diagnosed)
  );
}
export const normalRecords = (records, langs) => {
  let _records = [];
  for (let id = 0; id < records.length; id++) {
    let _record = { index: id, _id: records[id]._id };
    for (let idy in recordHeaders) {
      let key = recordHeaders[idy].prop;
      let options = recordHeaders[idy].options;
      if (key === "eyetype" && isDefined(records[id].eyetype)) {
        _record[key] =
          records[id].eyetype.length > 1
            ? records[id].eyetype.sort().join(",")
            : records[id].eyetype.sort().join("");
      } else {
        _record[key] = procData(records[id][key], key, options, langs);
      }
    }
    _records.push(_record);
  }
  return _records;
};
function getFileinfos(record) {
  let fileinfos = [];
  if (!isDefined(record) || !isDefined(record.content)) {
    return fileinfos;
  }
  let funcs = [
    ...DRYEYEMENUS.filter((val) => {
      return val.visibleInCapture;
    }),
    ...TOPOGRAPHYCAMPTUREMODES.filter((val) => {
      return val.visibleInCapture;
    })
  ];
  for (let key in record.content) {
    let fbutphotos = getKey(record, `content.${key}.fbut`);
    let fbut0 = fbutphotos ? fbutphotos[0].photos : undefined;
    let fbut1 = fbutphotos && fbutphotos[1] ? fbutphotos[1].photos : undefined;
    let fbut2 = fbutphotos && fbutphotos[2] ? fbutphotos[2].photos : undefined;
    if (isDefined(fbut0) && Array.isArray(fbut0)) {
      fileinfos = fileinfos.concat(fbut0);
    }
    if (isDefined(fbut1) && Array.isArray(fbut1)) {
      fileinfos = fileinfos.concat(fbut1);
    }
    if (isDefined(fbut2) && Array.isArray(fbut2)) {
      fileinfos = fileinfos.concat(fbut2);
    }
    for (let i = 0; i < funcs.length; i++) {
      let photos = getKey(record, `content.${key}.${funcs[i].key}.photos`);
      let upphotos = getKey(record, `content.${key}.${funcs[i].key}.up.photos`);
      let downphotos = getKey(record, `content.${key}.${funcs[i].key}.down.photos`);
      if (isDefined(photos) && Array.isArray(photos)) {
        fileinfos = fileinfos.concat(photos);
      }
      if (isDefined(upphotos) && Array.isArray(upphotos)) {
        fileinfos = fileinfos.concat(upphotos);
      }
      if (isDefined(downphotos) && Array.isArray(downphotos)) {
        fileinfos = fileinfos.concat(downphotos);
      }
    }
  }
  return fileinfos;
}
function delLocalFiles(p) {
  if (!fs.existsSync(p)) {
    return;
  }
  // 读取文件夹中所有文件及文件夹
  var list = fs.readdirSync(p);

  list.forEach((v, i) => {
    // 拼接路径
    var url = p + "/" + v;
    // 读取文件信息
    var stats = fs.statSync(url);
    // 判断是文件还是文件夹
    if (stats.isFile()) {
      // 当前为文件，则删除文件
      fs.unlinkSync(url);
    } else {
      // 当前为文件夹，则递归调用自身
      arguments.callee(url);
    }
  });
  // 删除空文件夹
  fs.rmdirSync(p);
}

// 调取用户列表接口用于导出 U盘
export const exportGetRecordsAll = (patientid, selectRecordValue, callback) => {
  var opt = {
    cmd: "exportGetRecordsAll",
    body: {
      patientid: patientid,
      selectRecordValue: selectRecordValue
    },
    token: window.token
  };
  httpRequest(opt, (response) => {
    if (response.message === "OK") {
      callback(response.obj);
    } else {
      console.log("error", response);
    }
  });
};



// WEBPACK FOOTER //
// ./src/services/record.js